import { IAccessGroupResponse } from "../../../model/base/response/access-group-response";
import { IAccessProfileResponse } from "../../../model/base/response/access-profile-response";
import { IPersonEntityResponse } from "../../../model/base/response/person-entity-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";

const defaultPath = 'Base';
let applicationData = ApplicationAppService.getApplicationData();
var baseUrl = applicationData.securityUrl;

const listAccessGroups = async (): Promise<IAccessGroupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/AccessGroups`
    }).then((response) => Object.assign([] as IAccessGroupResponse[], response.data));
};

const listAccessProfiles = async (): Promise<IAccessProfileResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/AccessProfiles`
    }).then((response) => Object.assign([] as IAccessProfileResponse[], response.data));
};

const listClients = async (): Promise<IPersonEntityResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Clients`
    }).then((response) => Object.assign([] as IPersonEntityResponse[], response.data));
};

const BaseAppService = {
    listAccessGroups,
    listAccessProfiles,
    listClients
};

export default BaseAppService;
